import instance from "./index";

const normalizeExpertise = (expertise) => ({
  ...expertise,
  expertiseId:
    expertise?.expertiseId ??
    expertise?.ExpertiseId ??
    expertise?.id ??
    expertise?.Id ??
    null,
  expertiseName:
    expertise?.expertiseName ??
    expertise?.ExpertiseName ??
    expertise?.name ??
    "",
  statusId: expertise?.statusId ?? expertise?.StatusId ?? null,
});

const extractList = (data) =>
  Array.isArray(data) ? data : Array.isArray(data?.data) ? data.data : [];

export const getAllExpertise = async () => {
  try {
    const response = await instance.get("/expertise/getAll");
    return extractList(response?.data).map(normalizeExpertise);
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.detail ||
      error?.message ||
      "Failed to load expertise";
    throw new Error(message);
  }
};

export const createExpertise = async ({ expertiseName }) => {
  const trimmed = String(expertiseName ?? "").trim();
  if (!trimmed) throw new Error("Expertise name is required");

  try {
    const response = await instance.post("/expertise", {
      expertiseName: trimmed,
    });
    const data = response?.data?.data ?? response?.data ?? {};
    return normalizeExpertise({
      ...data,
      expertiseName: data.expertiseName ?? trimmed,
    });
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.detail ||
      error?.message ||
      "Failed to create expertise";
    throw new Error(message);
  }
};
